import {
  IS_LOADING,
  API_URL,
  GET_ERRORS,
  UPDATE_ANALYSIS_PARAMS,
  SET_ANALYSIS,
  DELETE_RESULTS,
} from "./types";
import axios from "axios";
import { tokenConfig } from "../utils/tokenConfig";
import SuccessAlert from "../components/Modals/SuccessAlert";
import ErrorAlert from "../components/Modals/ErrorAlert";
import { resultsKeys } from "../utils/resultsKeys";

export const updateAnalysisParams = (key, value) => async (dispatch) => {
  dispatch({
    type: UPDATE_ANALYSIS_PARAMS,
    payload: { key, value },
  });
};

export const runSimulation =
  (analysis, history, getCasesAndProjects, openCase) => async (dispatch) => {
    dispatch({
      type: IS_LOADING,
    });
    try {
      dispatch({
        type: DELETE_RESULTS,
      });
      var data = {
        ...analysis,
      };
      // don't send results, they are too heavy
      resultsKeys.forEach((key) => {
        delete data[key];
      });
      const body = JSON.stringify(data);
      const getResults = async () => {
        try {
          const run_simulation = await axios.post(
            `${API_URL}/cases/${analysis.id}/run_simulation/`,
            body,
            tokenConfig()
          );
          // to get results (only the first key), open the case
          const res = await openCase(analysis.id, false, false);
          if (res === false) {
            ErrorAlert("An error occurred during the simulation.");
          } else {
            getCasesAndProjects();
            dispatch({
              type: IS_LOADING,
            });
            history.push("/dashboard/results/photovoltaic/productivity");
            SuccessAlert("Run completed!");
          }
        } catch {
          dispatch({
            type: IS_LOADING,
          });
          ErrorAlert("An error occurred during the simulation.");
        }
      };
      getResults();
    } catch (err) {
      console.log("eeeeeer");
      const errors = {
        msg: err.response.data,
        status: err.response.status,
      };
      dispatch({
        type: GET_ERRORS,
        payload: errors,
      });
    }
  };

export const getSingleResult = (id, list_keys) => async (dispatch) => {
  try {
    var res = {};
    var list_get = [];
    list_keys.forEach((key) => {
      list_get.push(
        axios.get(`${API_URL}/cases/${id}/results?key=${key}`, tokenConfig())
      );
    });
    await axios
      .all(list_get)
      .then(
        axios.spread((...responses) => {
          responses.forEach((single_res) => {
            res = { ...res, ...single_res.data };
          });
          dispatch({
            type: SET_ANALYSIS,
            payload: res,
          });
        })
      )
      .catch((errors) => {
        ErrorAlert("Cannot open selected case.");
      });
  } catch (err) {
    const errors = {
      msg: err.response.data,
      status: err.response.status,
    };
    dispatch({
      type: GET_ERRORS,
      payload: errors,
    });
  }
};
